import { render, staticRenderFns } from "./GerenciaCadastroPontos.vue?vue&type=template&id=34aeebe8"
import script from "./GerenciaCadastroPontos.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports